export enum DataHooks {
  WeekAvailability = 'week-availability',
  Loader = 'loader',
  DayAvailability = 'day-availability',
  DayDetails = 'day-details',
  DayWithoutSlots = 'day-without-slots',
  DayWithoutSlotsSrOnly = 'day-without-slots-sr-only',
  DayWithSlotsSrOnly = 'day-with-slots-sr-only',
}
